// Module
var code = "<am-input type=\"checked\"\n          ng-model=\"rowObj.selected\"\n          on-selected=\"toggleSelected(rowObj, $event)\"\n          checked-icon=\"icon-tick_in_circle\"\n          unchecked-icon=\"icon-circle-o\"\n          ng-class=\"{lastSelected: lastIndexSelected == rowObj.index}\">\n</am-input>\n";
// Exports
module.exports = code;